module.exports = __webpack_public_path__ + "img/vertical_7_5_5.85bb14af.png";